import I18n from "i18n-js";
import PropTypes from "prop-types";
import React from "react";

import { FlatList, View, StyleSheet, Text } from "react-native";
import fonts from "../constants/fonts";

import DependencyItem from "./DependencyItem";

const styles = StyleSheet.create({
  text: {
    ...fonts.regular,
    fontSize: 15,
    textAlign: "center",
    paddingTop: 50,
    marginHorizontal: 15,
    paddingBottom: 50,
  },
});

export default class DependencyList extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
  };

  renderItem = ({ fullName, cardNumber, gender, hasDoB }) => {
    const { onSelect } = this.props;

    return (
      <DependencyItem
        fullName={fullName}
        cardNumber={cardNumber}
        gender={gender}
        onSelect={() => {
          onSelect(cardNumber, fullName, hasDoB);
        }}
      />
    );
  };

  render() {
    const { data } = this.props;

    return data.length > 0 ? (
      <FlatList
        data={data}
        keyExtractor={(item) => item.cardNumber}
        renderItem={({ item }) => this.renderItem(item)}
      />
    ) : (
      <View>
        <Text style={styles.text}>
          {I18n.t("prixa.dependencyNotAvailable")}
        </Text>
      </View>
    );
  }
}
